import * as React from 'react';
import Header from '../Header/header';

export const Page = ({
  children
}: Pick<React.HTMLProps<HTMLDivElement>, 'children'>) => {
  return (
    <div className="cppn-planning">
      <Header />
      <main>{children}</main>
    </div>
  );
};
